import React from 'react';
import ExercisesPage from './ExercisesPage';

/**
 * The "Spiele" hub has been fully consolidated into ExercisesPage:
 * Conversación con IA, Ejercicios interactivos (AI + library) and mini-juegos
 * all live there now behind a single unified picker.
 */
export default function AITeacherHub() {
  return <ExercisesPage />;
}
